type TooltipContentProps = {
  conversationCount: number;
  conversationLimit: number;
  text: string;
};

export const TooltipContent = ({
  conversationCount: count,
  conversationLimit: limit,
  text,
}: TooltipContentProps): JSX.Element => <>{`${count} / ${limit} ${text}`}</>;
